export default __webpack_public_path__ + "static/media/2.04aa0afb.png";